<template>
  <header
    class="main-header animated"
    :class="{ closeLogo: sidebar.collapsed }"
  >
    <div class="logo">
      <span class="logo-lg">
        <img src="../../../assets/images-img/index_logo.png" />&nbsp;
        <!-- <b>极限加速器</b> -->
      </span>
    </div>
    <nav class="navbar">
      <a
        href="#"
        class="sidebar-toggle"
        role="button"
        @click.stop.prevent="toggleMenu()"
      >
        <img src="" alt="" srcset=""
      /></a>
      <div class="navbar-custom-menu">
        <!-- <span class="nav-custom-tag">
                    <i class="fa fa-envelope-o"></i>超级管理员
        </span>-->
        <!--<el-badge is-dot class="item">
                    <el-button class="share-button" icon="el-icon-share" type="danger" size="small"></el-button>
        </el-badge>-->
        <!-- 1212 -->
        <!-- <el-popover
          placement="bottom"
          width="370"
          trigger="click"
          @show="getIndexMsg"
          @hide="setIndexMsg"
        >
          <div style="width: 100%;height: 200px;overflow: auto;" class="infoBox">
            <li style="list-style-type: none;width:100%;height:50px" v-for="item in infoList">
              <p
                style="height:20px;line-height: 20px;color: #A9A9A9;font-size: 12px"
                v-html="messageTime(item.time)"
              ></p>
              <p
                style="font-size: 13px;margin-left: 10px;"
                :style="fontColor(item)"
              >{{item.message}}</p>
            </li>
          </div>
        <el-badge :value="infos" class="item" :type="badgeColor" slot="reference" :hidden="hideInfoNum">
                        <el-button size="small" icon="el-icon-bell" :type="badgeColor" ></el-button>
          </el-badge>
        </el-popover>-->

        <div class="title_img_hearder">
          <div>
            代理商管理后台
            <!-- <img src="../../../assets/day.png" alt=""/> -->
            <!-- <div  v-if="sstatusAgentType">官方一对一客服经理 ：{{agent_phone}}（{{manage_name}}）</div> -->
          </div>
        </div>

        <div class="rigth">
          <span class="span_right">
            <img src="../../../assets/logosg.png" alt />
            如有问题请进群反馈，如需加网吧版售后微信群请加微信号：11463484
          </span>
          <el-dropdown trigger="click" @command="handleCommand">
            <span class="el-dropdown-link" style="color: #98a0a6">
              欢迎：{{ agent_name }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="out">退出登录</el-dropdown-item>
              <el-dropdown-item command="change">修改密码</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </nav>
    <!-- x修改密码 -->
    <el-dialog
      title="修改密码"
      :visible.sync="changeAgent"
      width="30%"
      :append-to-body="true"
      center
    >
      <el-form
        label-width="120px"
        label-position="left"
        :model="changeData"
        :rules="rules"
        class="header_item"
        ref="changePsd"
      >
        <el-form-item label="原密码" prop="old_pwd">
          <el-input
            type="password"
            v-model="changeData.old_pwd"
            placeholder="请输入原始密码"
          ></el-input>
        </el-form-item>
        <el-form-item label="新的密码" prop="new_pwd1">
          <el-input
            type="password"
            v-model="changeData.new_pwd1"
            placeholder="请输入新密码"
          ></el-input>
        </el-form-item>
        <el-form-item label="确认新密码" prop="new_pwd2">
          <el-input
            type="password"
            v-model="changeData.new_pwd2"
            placeholder="请再次输入新密码"
          ></el-input>
        </el-form-item>
      </el-form>

      <!-- <div class="tips"><span>提示： 包月后台和扫码后台为同一账号</span></div> -->

      <div slot="footer" class="edit-footer">
        <el-button @click="changeAgent = false">取 消</el-button>
        <el-button type="primary" @click="changeOkBtn('changeData')"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </header>
</template>
<script>
import { mapGetters, mapMutations } from "vuex";
import types from "../../../store/mutation-types";
import * as sysApi from "../../../common/sys";
import { removeToken } from "@/utils/auth";
import { timestampToTime } from "../../../common/utils";

export default {
  data() {
    var validateoldPaw = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入原始密码"));
      }
      callback();
    };
    var validatenewPaw = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入新密码"));
      } else if (!/^[a-zA-Z0-9]{6,15}$/.test(value)) {
        callback(new Error("请输入7到15位由字母和数字组成的密码"));
      }
      callback();
    };
    var validateok_new = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入新密码"));
      } else if (value !== this.changeData.new_pwd1) {
        callback(new Error("两次密码输入不一致，请重新输入"));
      }
      callback();
    };
    return {
      sstatusAgentType: false, // 是否显示官方一对一客服经理
      QQ: "",
      agent_phone: "", //电话号码
      agent_name: "", // 昵称
      manage_name: "", // 客户经理名字
      infos: 0,
      infoList: [],
      changeAgent: false,
      changeData: {
        // oldPaw: "",   // 原密码
        // newPaw: "",  //  新密码
        // ok_new: "" , //   确定新密码

        new_pwd1: "", // 新密码
        new_pwd2: "", // 确定新密码
        old_pwd: "", // 原密码
      },
      rules: {
        old_pwd: [{ validator: validateoldPaw, trigger: "blur" }],
        new_pwd1: [{ validator: validatenewPaw, trigger: "blur" }],
        new_pwd2: [{ validator: validateok_new, trigger: "blur" }],
      },
    };
  },
  computed: {
    ...mapGetters({ sidebar: "sidebar" }),
    badgeColor() {
      return this.infos === 0 ? "success" : "danger";
    },
    hideInfoNum() {
      return this.infos === 0 ? true : false;
    },
  },
  created() {
    // this.getIndexInfos();
    this.agent_phone = localStorage.getItem("manage_phone");
    this.agent_name = localStorage.getItem("agent_name");
    this.manage_name = localStorage.getItem("manage_name");

    this.agent_type = localStorage.getItem("agent_type");

    this.agent();
    this.groupqq();
  },
  methods: {
    agent() {
      let agentType = localStorage.getItem("agent_type");
      if (
        agentType == "一级代理" ||
        agentType == "二级代理" ||
        agentType == "三级代理"
      ) {
        this.sstatusAgentType = true;
      }
    },
    groupqq() {
      let parme = { params: { status: 2 } };
      sysApi
        .read_qq(parme)
        .then((res) => {
          if (res.code != 1) {
            return this.$message.error(res.result);
          }
          this.QQ = res.result;
        })
        .catch((err) => console.log("请求异常信息：" + err));
    },

    messageTime(time) {
      return timestampToTime(time);
    },
    fontColor(item) {
      return item.bread === 0 ? "color:black;" : "color:#808080";
    },
    toggleMenu() {
      this.toggleSidebar();
    },
    loginOut() {
      window.localStorage.removeItem("agent_type");
      removeToken();

      // window.location.href="http://admin.bar.jixianjiasu.com"
      // window.location.href="http://192.168.11.150:8081/choiceMonthlyScanCode"
      this.$router.push({ path: "/login" });
    },
    // 修改密码
    changePassword() {
      this.changeAgent = true;
    },
    changeOkBtn() {
      this.$refs.changePsd.validate((valid) => {
        if (valid) {
          var param = {
            old_pwd: this.changeData.old_pwd,
            new_pwd1: this.changeData.new_pwd1,
            new_pwd2: this.changeData.new_pwd2,
          };
          sysApi
            .set_pwd(param)
            .then((res) => {
              if (res.code != 1) {
                return this.$message.error(res.result);
              }
              removeToken();
              this.$router.push({ path: "/login" });
              return this.$message.success("修改密码成功，请返回重新登录");
            })
            .catch((err) => console.log("请求异常信息：" + err));
        } else {
          return false;
        }
      });
    },
    handleCommand(command) {
      switch (command) {
        case "out":
          this.loginOut();
          break;
        case "change":
          this.changePassword();
          break;
        default:
          // this.changePassword();
          break;
      }
    },
    getIndexInfos() {
      sysApi.getIndexInfos().then((res) => {
        if (res.success) {
          this.infos = res.data;
        }
      });
    },
    getIndexMsg() {
      sysApi.getIndexMsg().then((res) => {
        if (res.success) {
          this.infoList = res.data;
        }
      });
    },
    setIndexMsg() {
      let arr = [];
      this.infoList.map((item) => {
        if (item.bread === 0) {
          arr.push(item.id);
        }
      });
      if (arr.length === 0) return;
      let str = arr.join(",");
      let param = { ids: str };
      sysApi.setIndexMsg(param).then((res) => {
        if (res.success) {
          this.infos = res.data;
        }
      });
    },
    ...mapMutations({
      toggleSidebar: types.TOGGLE_SIDEBAR,
      toggleSidebarShow: types.toggleSidebarShow,
    }),
  },
};
</script>

<style lang="scss" scoped>
.infoBox::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 4px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 4px;
}
.infoBox::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 5px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: rgba(0, 0, 0, 0.2);
}
.infoBox::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 0;
  background: rgba(0, 0, 0, 0.1);
}
.item {
  margin-right: 5px;
}

.header_item .el-form-item {
  margin-bottom: 20px !important;
}

.animated {
  animation-duration: 0.2s;
  background-color: #313148;
}

.el-dropdown-menu {
  width: 20% !important;
  right: 10px !important;
}

.main-header {
  position: fixed;
  min-width: 100%;
  // box-shadow: 0 2px 3px hsla(0, 0%, 7%, 0.1), 0 0 0 1px hsla(0, 0%, 7%, 0.1);
  z-index: 1999;
  color: #48576a;
  background: #ffffff;
  animation-name: slideInDown;
  animation-fill-mode: both;

  &.closeLogo {
    .navbar {
      margin-left: 44px;
      .sidebar-toggle {
        &::before {
          content: "\f03c";
        }
      }
    }
    .logo {
      width: 62px;
      // padding: 0 8px;
    }
  }
  .navbar-custom-menu {
    box-shadow: 0px 1px 18px 0px rgba(204, 204, 204, 0.6);
  }
  .navbar {
    -webkit-transition: margin-left 0.3s ease-in-out;
    -o-transition: margin-left 0.3s ease-in-out;
    transition: margin-left 0.3s ease-in-out;
    margin-bottom: 0;
    margin-left: 230px;
    min-height: 60px;
    border: none;
    background-color: #ffffff;
    border-radius: 0;
    height: 60px;
    overflow: hidden;
    .navbar-custom-menu {
      display: flex;
      justify-items: center;
      align-items: center;
      i.fa {
        margin-right: 10px;
      }
      .el-dropdown {
        background: #fff;
        text-align: center;
        padding-right: 80px;

        // &:hover {
        //   background: #48d1cc;
        // }
        .el-dropdown-link {
          cursor: pointer;
          height: 60px;
          line-height: 60px;
          // width: 90px;
        }
      }
    }
    .sidebar-toggle {
      display: block;
      float: left;
      background-color: #f3f3ff;
      background-image: none;
      padding: 20px 15px;
      line-height: 20px;
      box-shadow: 0px 1px 18px 0px rgba(204, 204, 204, 0.6);
      font-family: fontAwesome;
      font-size: 18px;
      &:before {
        content: "\f03b";
      }
      &:hover {
        // background: #f9f9f9;
      }
    }
  }
  .logo {
    -webkit-transition: width 0.3s ease-in-out;
    -o-transition: width 0.3s ease-in-out;
    transition: width 0.3s ease-in-out;
    display: block;
    float: left;
    height: 60px;
    line-height: 60px;
    text-align: center;
    width: 280px;
    // box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
    background-color: #313148;
    font-size: 20px;
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    padding: 0 15px;
    font-weight: 300;
    overflow: hidden;
    text-decoration: none;
    text-align: left;
    .logo-lg {
      // display: block;
      height: 38px;
      line-height: 38px;
      img {
        width: 235px;
        height: 42px;
        vertical-align: middle;
      }
      b {
        vertical-align: middle;
      }
    }
  }
  a {
    text-decoration: none;
    color: #48576a;
  }
}
.title_img_hearder {
  color: #3a3a53;
  font-size: 16px;
  padding-left: 30px;
  float: left;
  div {
    width: 114px;
  }
}
.rigth {
  width: 100%;
  text-align: right;
}
.span_right {
  position: relative;
  padding-right: 184px;
  color: #98a0a6;
  font-size: 16px;
  img {
    position: absolute;
    top: 2px;
    left: -25px;
    width: 15px;
    height: 15px;
    -webkit-animation-name: scaleDraw; /*关键帧名称*/
    -webkit-animation-timing-function: ease-in-out; /*动画的速度曲线*/
    -webkit-animation-iteration-count: infinite; /*动画播放的次数*/
    -webkit-animation-duration: 1s; /*动画所花费的时间*/
  }
}
@keyframes scaleDraw {
  /*定义关键帧、scaleDrew是需要绑定到选择器的关键帧名称*/
  0% {
    transform: scale(1); /*开始为原始大小*/
  }
  25% {
    transform: scale(1.1); /*放大1.1倍*/
  }
  50% {
    transform: scale(1);
  }
  75% {
    transform: scale(1.1);
  }
}
.el-dropdown-link:hover {
  color: #fdcf13 !important;
}
.el-dropdown-selfdefine:hover {
  color: #fdcf13 !important;
}

.tips {
  color: #ed709c;
  text-align: center;
}
</style>
